import React from 'react';
import PropTypes from 'prop-types';

export default function Capsule(props) {
  const { className, text, onRemove, id } = props;
  return(
    <div className={`capsule ${className}`}>
      { onRemove && <div className="remove-button">
          <span onClick={() => onRemove(id)} className="icon-close_icon"></span>
        </div>
      }
      <span className="text-bold text">{text}</span>
    </div>
  )
}

Capsule.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  className: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onRemove: PropTypes.func
}
